import React from 'react';
import Text from '../Text';
import CardContainer from '../CardContainer';
import Button from '../Button';
import viewIcon from '../../images/view.png';
import './ImageChooseCard.less';

export type ImageChooseCardProps = {
  src?: string;
  height?: string;
  buttonText: string;
  value?: any;
  selected?: boolean;
  fullScreenButton?: boolean;
  handleChoose?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  templateName?: string;
  url?: string;
};

const TImageChooseCard: React.FC<ImageChooseCardProps> = ({
  src,
  height,
  buttonText,
  handleChoose,
  value,
  selected,
  fullScreenButton = true,
  templateName,
  url,
}) => {
  const [fullScreen, setFullScreen] = React.useState(false);

  const classNames = [
    't-image-choose-card-wrapper',
    selected && `t-image-choose-card-selected`,
  ];
  const makeFullScreen = () => {
    setFullScreen(!fullScreen);
  };

  const onChange = () => {
    handleChoose(value);
  };

  return (
    <>
      <div className={classNames.join(' ')}>
        <CardContainer background="light-100">
          <img className="t-choose-image" src={src} style={{ height }} />
          <div className="t-choose-card-buttons">
            <Button size="large" onClick={onChange}>
              {buttonText}
            </Button>
            {url && (
              <div className="t-choose-card-viewIcon">
                <a href={url} target="_blank">
                  <img src={viewIcon} />
                </a>
              </div>
            )}
            {fullScreenButton && !url && (
              <div className="t-choose-card-viewIcon" onClick={makeFullScreen}>
                <img src={viewIcon} />
              </div>
            )}
          </div>
          <div className="t-template-name">
            <Text>{templateName}</Text>
          </div>
        </CardContainer>
      </div>
      {fullScreen && (
        <div
          className="t-choose-image-full-screen-container"
          onClick={() => setFullScreen(false)}
        >
          <img className="t-choose-image-full-screen" src={src} />
        </div>
      )}
    </>
  );
};

export default TImageChooseCard;
